import { Private_Routes } from '@common/url';
import { ExtractUrlPathVariables } from '@prophecy/interfaces/generic';
import { useGlobalVariables } from 'frontend/core/src/context/globalConfig/securedConfigHook';
import { useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useImmer } from 'use-immer';

import { FileFormats, PipelineEntityType } from '../config';
import { getJobFolderType } from './steps/getJobFolderType';
import { ImportStepValue, TreeItem } from './steps/types';
import { TranspilerStateType, UseProjectBrowserState } from './types';

export const useProjectBrowserState = (): UseProjectBrowserState => {
  const [projectBrowserWidth, _setProjectBrowserWidth] = useState(310);
  const [treeData, setTreeData] = useState<TreeItem[]>([]);

  return { projectBrowserWidth, _setProjectBrowserWidth, treeData, setTreeData };
};

export const useTranspilerInitialState = (name: string, uid?: string) => {
  const params = useParams<ExtractUrlPathVariables<typeof Private_Routes.TranspilerImport.tab.url>>();
  const pipelinesEntityType: PipelineEntityType[] = [];
  const [searchParams] = useSearchParams();
  const step = searchParams.get('step');
  const [transpilerState, setTranspilerState] = useImmer<TranspilerStateType>({
    transpilerId: uid || params.transpileId || '',
    isUpdate: false,
    pipelineWithErrors: [],
    jobWithErrors: [],
    transpilerEntityTypes: {
      pipelines: pipelinesEntityType,
      jobs: [],
      datasets: []
    },
    step,
    activeStep: step !== undefined ? Number(step) : ImportStepValue.Sources,
    uploadedFilePaths: []
  });
  return { transpilerState, setTranspilerState };
};

export function useAcceptedFormats(source: FileFormats) {
  const isAbinitio = source === FileFormats.abinitio;
  const isJobEnabled = useGlobalVariables().isTranspilerJobEnabled;

  const supportedFilesArray = getJobFolderType(source, !!isJobEnabled);
  const supportedFiles = supportedFilesArray.join(', .');
  const supportedFormatString = '.' + supportedFiles + (isAbinitio ? ',..., .zip' : '');

  return supportedFormatString;
}
